<script>
export default {
  name: 'MeetingEventNumber',
  props: {
    eventNumber: {
      type: Number,
      required: true,
    },
    activeEventNumber: {
      type: String,
      required: true,
    },
    activeView: {
      type: String,
      required: true,
    },
    eventId: {
      type: String,
      required: true,
    },
    eventStatus: {
      type: String,
      required: true,
    },
    prefixText: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isEventActive: false,
    };
  },
  computed: {
    getViewUrl() {
      return this.activeView ? `${this.eventNumber}#${this.activeView}` : `${this.eventNumber}`;
    },
    eventResulted() {
      return this.eventStatus === 'ResultsDone' || this.eventStatus === 'Accepted';
    },
    eventAbandoned() {
      return this.eventStatus === 'Abandoned' || this.eventStatus === 'Cancelled';
    },
  },
  mounted() {
    const { eventNumber, activeEventNumber } = this;
    if (eventNumber == activeEventNumber) {
      this.isEventActive = true;
    }
  },
  methods: {
    updateSelectedEvent() {
      this.isEventActive = false;
    },
  },
};
</script>

<template>
  <a
    :data-event-id="`${eventId}`"
    :class="{ 'meeting-event-closed': eventResulted, 'meeting-event-abandoned': eventAbandoned, 'meeting-event-active': isEventActive }"
    :href="getViewUrl"
    class="meeting-event-number"
    @click.prevent="updateSelectedEvent"
  >
    <div class="meeting-event-number__text">
      <span v-if="prefixText">R</span>
      {{ eventNumber }}
    </div>
  </a>
</template>
